import { useQuery } from '@tanstack/react-query'
import sliderDummy from '../../dataContainer/imageSliderData.json'
import hotSellDummy from '../../dataContainer/hotSellData.json'
import promotionDataDummy from '../../dataContainer/promocionSliderData.json'
import recommendedProductsDummy from '../../dataContainer/recommendedProductsData.json'
import hitsOfTheWeekDummy from '../../dataContainer/hitsOfWeekData.json'
import BestsellersDummy from '../../dataContainer/BestsellersData.json'
import { ImageToSlide } from './imageSlider/Types';
import { HotSellProduct } from './hotSellPanel/Types';
import { RecommendedProduct } from './recommendedProducts/Types';
import { Promotion } from './promotions/Types';
import { HitOfWeekProduct } from './hitsOfTheWeekSlider/Types'
import { BestsellerProduct } from './bestsellers/Types'

//TODO: update me, when api will be written
const getImagesSlider = (): Promise<ImageToSlide[]> => {
  return Promise.resolve(sliderDummy)
}

export const useImageSliderQuery = () => {
  return useQuery<ImageToSlide[], { message: string }>(['imageSlider'], getImagesSlider)
}

const getHotSellProduct = (): Promise<HotSellProduct> => {
  return Promise.resolve(hotSellDummy)
}

export const useHotSellQuery = () => {
  return useQuery<HotSellProduct, { message: string }>(['hotSell'], getHotSellProduct)
}

const getRecommendedProducts = (): Promise<RecommendedProduct[]> => {
  return Promise.resolve(recommendedProductsDummy)
}

export const useRecomendedProductsQuery = () => {
  return useQuery<RecommendedProduct[], { message: string }>(['recommendedProducts'], getRecommendedProducts)
}

const getPromotionPagination = (): Promise<Promotion[]> => {
  return Promise.resolve(promotionDataDummy)
}

export const usePromotionPaginationQuery = () => {
  return useQuery<Promotion[], { message: string }>(['promotions'], getPromotionPagination)
}

const getHitsOfWeekProducts = (): Promise<HitOfWeekProduct[]> => {
  return Promise.resolve(hitsOfTheWeekDummy)
}

export const useHitsOfWeekProductsQuery = () => {
  return useQuery<HitOfWeekProduct[], { message: string }>(['hitsOfWeekProducts'], getHitsOfWeekProducts)
}

const getBestsellerProducts = (): Promise<BestsellerProduct[]> => {
  return Promise.resolve(BestsellersDummy)
}

export const useBestsellerProductsQuery = () => {
  return useQuery<BestsellerProduct[], { message: string }>(['Bestsellers'], getBestsellerProducts)
}